import { logger } from "../core/logger";
import { THEME_EVENTS, publish } from "../../shared/events";
import { fetchConfig } from "../core/utils";

class ZiggyPlanSelector extends HTMLElement {
  constructor() {
    super();

    this.cartItems =
      document.querySelector("cart-drawer-items") ||
      document.querySelector("cart-items");

    this.cartSubscriptionsContainer =
      document.getElementById("js_abo_container");
    //this.currentPlan = "";
    this.currentPlan = this.querySelector(
      'input[name="selling-plans"]:checked',
    ).value;

    this.selector = this.querySelector(".js-selector");
    this.options = this.querySelectorAll(".option");
    this.selectLabel = this.querySelector(".js-select-label");

    this.selectedVariant = "";

    this.addEventListener("click", this.handleClick.bind(this));

    document.addEventListener("click", (event) => {
      if (
        event.target === this.selector ||
        this.selector.classList.contains("dropdown-is-closed")
      )
        return;
      this.toggleIsClosed();
    });
  }

  connectedCallback() {
    this.addEventListener("mousedown", function (event) {
      if (
        !event.target.parentElement.classList.contains("js-dropdownSelect") &&
        !event.target.parentElement.classList.contains("js-selectGroup")
      ) {
        document
          .querySelectorAll(".js-selector")
          .forEach((selector) => selector.classList.add("dropdown-is-closed"));
      }
    });
  }

  handleClick(event) {
    if (this.isUpdatingPlan) return;
    event.preventDefault();

    // OUVERTURE
    if (event.target === this.selector) {
      this.toggleIsClosed();
      return;
    }

    // CLICK SUR OPTION
    if (!event.target.classList.contains("select-item")) return;

    const selectedPlan = event.target.textContent.trim();

    logger.info("ZiggyRadioSelect", "selectedPlan", selectedPlan);

    // Update label UI (comme ton code initial)
    const allSelectLabel = [...document.querySelectorAll(".js-select-label")];

    allSelectLabel.forEach((label) => {
      label.innerHTML = event.target.innerHTML;
    });

    // Cocher le radio correspondant
    const radio = this.querySelector(`input[value="${selectedPlan}"]`);
    if (radio) radio.checked = true;

    this.toggleIsClosed();

    if (selectedPlan === this.currentPlan) return;

    const checkoutBtn = document.querySelector("button[name='checkout']");
    if (checkoutBtn) checkoutBtn.disabled = true;

    this.updateAllSubscriptions(selectedPlan);
  }

  async updateAllSubscriptions(planName) {
    // 🔹 1. Ne rien faire si même fréquence
    if (planName === this.currentPlan) return;

    this.isUpdatingPlan = true;
    this.classList.add("pointer-events-none", "opacity-70");

    const abos = this.cartSubscriptionsContainer.querySelectorAll(".cart-item");

    abos.forEach((item) => {
      item.classList.add("is-updating-plan");
    });

    const checkoutBtn = document.querySelector("button[name='checkout']");
    if (checkoutBtn) checkoutBtn.disabled = true;

    try {
      for (let i = 0; i < abos.length; i++) {
        const item = abos[i];

        const key = item.dataset.key;
        const qty = parseInt(item.dataset.qty, 10);
        if (!key || !qty || Number.isNaN(qty)) continue;

        const plansScript = item.querySelector(
          'script[type="application/ld+json"]#cartItemSellingPlans',
        );
        if (!plansScript) continue;

        const planArray = JSON.parse(plansScript.textContent);

        const matchingPlan = planArray.selling_plans.find(
          (sellingPlan) => sellingPlan.name === planName,
        );
        if (!matchingPlan) continue;

        const body = JSON.stringify({
          id: key,
          quantity: qty,
          selling_plan: parseInt(matchingPlan.id, 10),
        });

        const response = await fetch(`${theme.routes.cart_change_url}`, {
          ...fetchConfig(),
          body,
        });

        await response.json(); // on consomme la réponse
      }

      this.currentPlan = planName;

      publish(THEME_EVENTS.cartUpdate, {
        source: "radio-select",
        currentPlan: this.currentPlan,
      });
    } catch (error) {
      logger.error("ZiggyRadioSelect", "Error", error);
    } finally {
      // 🔹 Retirer overlay global
      abos.forEach((item) => {
        item.classList.remove("is-updating-plan");
      });

      this.classList.remove("pointer-events-none", "opacity-70");
      this.isUpdatingPlan = false;

      if (checkoutBtn) checkoutBtn.disabled = false;
    }
  }

  toggleIsClosed() {
    this.selector.classList.toggle("dropdown-is-closed");
  }

  async updateItemSubscription(plan) {
    if (this.isUpdatingPlan) return;
    this.isUpdatingPlan = true;

    const checkoutButton = document.querySelector("button[name='checkout']");

    try {
      this.classList.add("opacity-60", "pointer-events-none");
      if (checkoutButton) checkoutButton.disabled = true;

      const abos =
        this.cartSubscriptionsContainer.querySelectorAll(".cart-item");

      for (const item of abos) {
        logger.info("ZiggyRadioSelect", "abos", abos);
        logger.info("ZiggyRadioSelect", "item", item);
        const planArray = JSON.parse(
          item.querySelector('[type="application/json"]').textContent,
        );

        const newSellingPlanId = planArray.selling_plans.find(
          (selling_plan) => selling_plan.name === plan,
        ).id;

        if (!newSellingPlanId) continue;

        const quantityWrapper = item.querySelector("quantity-input");
        const quantityInput = item.querySelector(".js-cart-qty-input");

        if (!quantityWrapper || !quantityInput) continue;

        if (!this.cartItems) {
          console.warn("CartItems component not found");
          return;
        }

        /*this.cartItems.updateSellingPlanByKey(
          quantityWrapper.dataset.key,
          parseInt(quantityInput.value, 10),
          parseInt(newSellingPlanId),
        );*/

        logger.info("ZiggyRadioSelect", "body", {
          id: quantityWrapper.dataset.key,
          quantity: parseInt(quantityInput.value, 10),
          selling_plan: parseInt(newSellingPlanId),
        });
      }

      this.currentPlan = plan;

      publish(THEME_EVENTS.cartUpdate, {
        source: "radio-select",
        currentPlan: this.currentPlan,
      });
    } catch (error) {
      console.error(error);
    } finally {
      this.classList.remove("opacity-60", "pointer-events-none");
      if (checkoutButton) checkoutButton.disabled = false;
      this.isUpdatingPlan = false;
    }
  }
}
if (!customElements.get("ziggy-plan-selector")) {
  customElements.define("ziggy-plan-selector", ZiggyPlanSelector);
}
